import { map, OperatorFunction } from 'rxjs';

import { ApiMetaBase, ApiResponseBase, ApiResponseBaseNonNull } from '../types';

import { assertNonNull } from './assert-non-null';

export function mapDataNonNull<TDto, TDomain, M extends ApiMetaBase>(
  fn: (dto: TDto) => TDomain,
): OperatorFunction<ApiResponseBase<TDto, M>, ApiResponseBaseNonNull<TDomain, M>> {
  return map((res) => {
    assertNonNull(res.data);

    return {
      data: fn(res.data),
      meta: res.meta,
    };
  });
}
